import angular = require('angular');
import {
  CassaPrevidenzialeModalModule
} from './cassa-previdenziale-modal-component/cassa-previdenziale-modal-component.module';
import {ExportComponentModule} from './export-component/export-component.module';
import {LendingProviderModule} from './lending-provider/lending-provider.module';
import {NotificationsModalModule} from './notifications-modal-component/notifications-modal-component.module';
import {PaymentModeSelectorModule} from './payment-mode-selector/payment-mode-selector.module';
import {
  ScontoMaggiorazionePRModalModule
} from './sconto-maggiorazione-modal-component/sconto-maggiorazione-modal-component.module';

export const FatturazioneComponentModule = angular
  .module('fatturazione.component', [
    CassaPrevidenzialeModalModule,
    ExportComponentModule,
    LendingProviderModule,
    NotificationsModalModule,
    PaymentModeSelectorModule,
    ScontoMaggiorazionePRModalModule
  ])
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/fatturazione-component.module.ts